export default "__VITE_PUBLIC_ASSET__1dca082a__"